import axiosInstance from "@/api/axios-instance";
import {
  CreateProfessionalInput,
  CreateProfessionalWithFiles,
} from "../services/create-professional";

function buildProfessionalFormData(
  data: CreateProfessionalWithFiles
): FormData {
  const formData = new FormData();

  formData.append("name", data.name.trim());
  formData.append("type", data.type);
  formData.append("sex", data.sex.trim());
  // status is changed through PATCH /professional/:id/status only (RH-506)
  if (data.date_of_birth) formData.append("date_of_birth", data.date_of_birth);
  if (data.email) formData.append("email", data.email);
  if (data.phone_number) formData.append("phone_number", data.phone_number);
  if (data.registration_number)
    formData.append("registration_number", data.registration_number);
  if (
    data.years_of_experience !== null &&
    data.years_of_experience !== undefined
  )
    formData.append("years_of_experience", data.years_of_experience.toString());
  if (data.personal_email)
    formData.append("personal_email", data.personal_email);
  if (data.address) formData.append("address", data.address);
  if (data.country) formData.append("country", data.country);
  if (data.specialization)
    formData.append("specialization", data.specialization);
  if (data.university_name)
    formData.append("university_name", data.university_name);
  if (data.bio) formData.append("bio", data.bio);
  if (data.preferred_notification_number)
    formData.append(
      "preferred_notification_number",
      data.preferred_notification_number
    );
  if (data.pronouns) formData.append("pronouns", data.pronouns);
  if (data.supervisor_id) formData.append("supervisor_id", data.supervisor_id);
  (data.lead_ids || []).forEach((leadId: string) => {
    formData.append("lead_ids", leadId);
  });
  if (data.job_commitment)
    formData.append("job_commitment", data.job_commitment);
  if (data.department) formData.append("department", data.department);

  (data.languages || []).forEach((lang: string) => {
    formData.append("languages", lang);
  });

  if (data.qualification) {
    formData.append("qualification", JSON.stringify(data.qualification));
  }
  if (data.area_of_expertise) {
    formData.append(
      "area_of_expertise",
      JSON.stringify(data.area_of_expertise)
    );
  }
  if (data.associated_teams) {
    formData.append(
      "associated_teams",
      JSON.stringify(data.associated_teams)
    );
  }
  (data.age_range_minor || [0, 17]).forEach((num) =>
    formData.append("age_range_minor", num.toString())
  );
  (data.age_range_adult || [18, 100]).forEach((num) =>
    formData.append("age_range_adult", num.toString())
  );

  formData.append("is_married", String(data.is_married ?? false));
  formData.append("has_kid", String(data.has_kid ?? false));
  formData.append("is_supervisor", String(data.is_supervisor ?? false));
  formData.append("is_lead", String(data.is_lead ?? false));

  if (data.picture) formData.append("picture", data.picture);
  if (data.signature) formData.append("signature", data.signature);
  if (data.stamp) formData.append("stamp", data.stamp);
  if (data.stamp_and_signature)
    formData.append("stamp_and_signature", data.stamp_and_signature);
  if (data.professional_image)
    formData.append("professional_image", data.professional_image);

  return formData;
}

export async function updateProfessional(
  id: string,
  data: CreateProfessionalWithFiles
) {
  const formData = buildProfessionalFormData(data);

  const response = await axiosInstance.patch(`/professional/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to update professional");
  }

  return response.data;
}
